/**
 * Where the API lives.
 *
 * Set `REACT_APP_API_URL` in Netlify for production builds; the localhost
 * default is what `npm run dev` uses.
 *
 * There is deliberately no endpoint-constants map here. One existed and drifted
 * — it still listed `/api/contact` from the marketing site long after that route
 * was deleted, and nothing imported it, so nothing caught the rot. Paths live at
 * their call sites next to the code that uses them, where a stale one is visible.
 */

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5001';

export default API_BASE_URL;
